<template>
  <div>
    <b-form @submit.prevent="sendFilteredQuery">
      <b-row>
          <!--CREATED DATE RANGE-->
          <b-form-group
            id="created-group"
            :invalid-feedback="invalidCreatedDate"
            :state="stateCreatedDate"
            class="ml-3 input-width"
            label-for="created"
          >
            <VueCtkDateTimePicker
              id="created"
              :custom-shortcuts="defaultDatepickerShortcuts"
              v-model="filterModels.dateRange"
              :no-clear-button="true"
              :error="!stateCreatedDate"
              @is-hidden="applyDateRange"
              :autoClose="true"
              @validate="sendFilteredQuery"
              :hint="$t('pages.customer_payment_report.date_hint')"
              :locale="$_languageCode"
              :format="dateFormat"
              :formatted="dateFormat"
              outputFormat="YYYY-MM-DDTHH:mmZ"
              :range="true"
            >
            </VueCtkDateTimePicker>
          </b-form-group>
          <!--RECORD TYPE (KIND)-->
          <b-form-group
            class="input-width mh-100 ml-3"
            id="type-group"
          >
            <multiselect
              id="type"
              class="input-height scrollable-multiselect"
              :class="{ 'invalid-multiselect': !stateCreatedDate }"
              :select-label="$t('multiselect.select_label')"
              :selected-label="$t('multiselect.selected_label')"
              @select="sendFilteredQuery"
              @remove="sendFilteredQuery"
              v-model="filterModels.kind"
              :placeholder="$t('multiselect.placeholder', { field: $t('table.booking_requests.type').toLowerCase() })"
              :searchable="false"
              track-by="code"
              label="name"
              :options="bookingTypes">
            </multiselect>
          </b-form-group>

          <b-button
            class="bootstrap-input-height ml-3 mb-1"
            @click="showActiveBookingRequests"
            variant="success">
            {{ $t('filter.by.booking_requests.show_active') }}
          </b-button>
          <b-button
            class="bootstrap-input-height ml-3 mb-1"
            @click="showAllBookingRequests"
            variant="info">
            {{ $t('filter.by.booking_requests.show_all') }}
          </b-button>

          <b-button
            class="bootstrap-input-height ml-3 mb-1"
            @click="clearAllFilters"
            :disabled="loading"
            variant="primary">
            <b-icon icon="arrow-repeat"></b-icon>
            {{ $t('filter.reset_button') }}
          </b-button>
      </b-row>
    </b-form>
  </div>
</template>

<script>
  import moment from 'moment'
  import {
    BOOKING_EXPIRED,
    BOOKING_REQUEST_STATUSES,
    BOOKING_TYPES,
    DEFAULT_DATEPICKER_SHORTCUTS, getDateFormat,
  } from '@base/configs'
  import {mapState} from "vuex";

  const defaultFilterModels = {
    dateRange: {
      start: moment().subtract({month: 6}).startOf('month').format('YYYY-MM-DD'),
      end: moment().add({month: 12}).endOf('month').format('YYYY-MM-DD'),
    },
    status: BOOKING_REQUEST_STATUSES.filter(obj => obj.code !== BOOKING_EXPIRED),
    kind: null,
  }
  
  export default {
    name: 'BookingRequestFilter',

    data () {
      return {
        defaultDatepickerShortcuts: DEFAULT_DATEPICKER_SHORTCUTS,
        filterModels: {
          ...defaultFilterModels,
        },
        invalidCreatedDate: null,
        bookingRequestStatuses: BOOKING_REQUEST_STATUSES,
        bookingTypes: BOOKING_TYPES,
        loading: false,
      }
    },

    watch: {
      'filterModels.dateRange'() {
        this.invalidCreatedDate = null
      }
    },

    computed: {
      ...mapState(['userMarket']),

      dateFormat() {
        return getDateFormat(this.userMarket?.supportCountry?.code)
      },

      filterArgs () {
        const startDate = moment.parseZone(this.filterModels.dateRange.start).format('YYYY-MM-DD')
        const endDate = moment.parseZone(this.filterModels.dateRange.end).format('YYYY-MM-DD')

        return {
          startDate: startDate,
          endDate: moment(endDate).add(1, 'days').format('YYYY-MM-DD'),
          status: this.statusArg,
          kind: this.kindArg
        }
      },

      statusArg () {
        return this.filterModels.status ? this.filterModels.status.map((statusObj) => statusObj.code) : null
      },

      kindArg () {
        return this.filterModels.kind ? this.filterModels.kind.code : null
      },

      isSaleDateValid () {
        if (!this.filterModels.dateRange)
          return false
        return !!this.filterModels.dateRange.start || !!this.filterModels.dateRange.end
      },
      stateCreatedDate () {
        return (this.invalidCreatedDate === null)
      },
    },

    created() {
      this.sendFilteredQuery()
    },

    methods: {
      applyDateRange () {
        this.$nextTick(this.sendFilteredQuery)
      },

      clearAllFilters () {
        this.loading = true
        this.filterModels = { ...defaultFilterModels }
        this.$store.commit(this.$_mutationTypes.SET_BOOKINGS_FILTERS, this.filterArgs)
        this.$emit('filter-applied')
        this.loading = false
      },

      sendFilteredQuery () {
        if (!this.isSaleDateValid) {
          this.invalidCreatedDate = this.$t('validation.date_range')
          return
        }
        this.$store.commit(this.$_mutationTypes.SET_BOOKINGS_FILTERS, this.filterArgs)
        this.$emit('filter-applied')
      },
      showActiveBookingRequests () {
        this.filterModels = {
          ...this.filterModels,
          status: BOOKING_REQUEST_STATUSES.filter(obj => obj.code !== BOOKING_EXPIRED),
        }
        this.$store.commit(this.$_mutationTypes.SET_BOOKINGS_FILTERS, this.filterArgs)
        this.$emit('filter-applied', this.filterArgs)
      },

      showAllBookingRequests () {
        this.filterModels = {
          ...this.filterModels,
          status: BOOKING_REQUEST_STATUSES,
        }
        this.$store.commit(this.$_mutationTypes.SET_BOOKINGS_FILTERS, this.filterArgs)
        this.$emit('filter-applied', this.filterArgs)
      },
    }
  }
</script>

<style scoped>
.input-width {
  min-width: 300px !important;
  max-width: 300px !important;
}


/* Make tag list scroll horizontally, but allow dropdown to function */
.scrollable-multiselect >>> .multiselect__tags {
  max-width: 100%;
  border: 1px solid rgba(0,0,0,.2) !important;
  border-radius: 4px !important;
  background-color: #fff !important;
  height: 42px !important;
  box-shadow: none !important;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  display: block;
  padding-right: 8px;
  padding-left: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
}

/* Optional WebKit scrollbar */
.scrollable-multiselect >>> .multiselect__tags::-webkit-scrollbar {
  height: 6px;
}
.scrollable-multiselect >>> .multiselect__tags::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 3px;
}

/* Keep input working (no hacks) */
.scrollable-multiselect >>> .multiselect__input {
  width: auto;
  min-width: 10px;
}

/* Prevent tags from wrapping */
.scrollable-multiselect >>> .multiselect__tag {
  display: inline-block;
  margin-right: 6px;
  white-space: nowrap;
}

/* Error state */
.invalid-multiselect >>> .multiselect__tags {
  border-color: #dc3545 !important;
}
</style>

